export default __webpack_public_path__ + "static/personal_321-d1a0e18833e59b57ac5a25fb37ece568.jpg";